import { getDelegationTokenForOwa, getAccessTokenforResourceAsLazy } from 'owa-tokenprovider';
import { MSATOKENSCOPE, ODSRESOURCEURI } from '../FeedbackConstants';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

export default async function getTokenForOds(): Promise<string> {
    let token = null;
    if (isConsumer()) {
        token = await getDelegationTokenForOwa(MSATOKENSCOPE);
    } else {
        token = await GetAccessTokenForBusiness();
    }
    return token;
}

async function GetAccessTokenForBusiness() {
    let [token, tokenPromise] = getAccessTokenforResourceAsLazy(ODSRESOURCEURI);

    if (!token) {
        token = await tokenPromise;
    }
    return token;
}
